import Vue from 'vue';
import VueHighlightJS from 'vue-highlightjs';
Vue.use(VueHighlightJS);
